<template lang="pug">
  transition(:name="animationType")
    div(
      :class="{'modal-auto-height' : autoHeight}"
    ).e-modal.smallModal.open
      div(
        :class="modalClass"
        @click.self="onOuterClickClose()"
      )
        div.modal
          div.modal_container
            div(v-if="showHeader").header
              template(v-if="$slots.header")
                slot(name="header")
              template(v-else)
                span.close(@click.self="close")
                h1.title {{$translate(title)}}
            div.body-wrapper
              div
                slot
            div(v-if="showFooter").footer
              div(v-if="$slots.footer").actions-filter-panel
                slot(name="footer")
              div(
                v-else
                :class="{'actions-filter-panel--right': !showDeleteBtn}"
              ).actions-filter-panel
                button(
                  v-if="showDeleteBtn"
                  type="button"
                  :disabled="freezeAllEvents"
                  @click="deleteItem()"
                ).actions-filter-panel__button.standart.standart-delete {{$translate(removeBtnLabel)}}
                div
                  button.actions-filter-panel__button.standart.standart-noborder(
                    type="button"
                    :disabled="freezeAllEvents"
                    @click="close"
                  ) {{$translate(closeBtnLabel)}}
                  button.actions-filter-panel__button.standart(
                    v-if="showSavedBtn"
                    type="button"
                    :disabled="freezeAllEvents"
                    @click="confirm"
                  ) {{$translate(saveBtnLabel)}}
</template>

<script>
  import modalHelper from './modal-helper'

  export default {
    name: 'e-modal',
    mixins: [modalHelper],
    props: {
      title: {
        type: String,
        default: 'Внимание'
      },
      showFooter: {
        type: Boolean,
        default: true
      },
      showHeader: {
        type: Boolean,
        default: true
      },
      modalClass: {
        type: String,
        default: 'fixed-overlay fixed-overlay__modal'
      },
      animationType: {
        type: String,
        default: 'fade'
      },
      outerClickClose: {
        type: Boolean,
        default: false
      },
      closeBtnLabel: {
        type: String,
        default: 'Отмена'
      },
      saveBtnLabel: {
        type: String,
        default: 'Сохранить'
      },
      removeBtnLabel: {
        type: String,
        default: 'Удалить'
      },
      autoHeight: {
        type: Boolean,
        default: false
      },
      showSavedBtn: {
        type: Boolean,
        default: true
      },
      showDeleteBtn: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onOuterClickClose () {
        if (this.outerClickClose) {
          this.close()
        }
      },
      close () {
        if (this.freezeAllEvents === true) {
          return
        }

        this.$emit('close')
      },
      confirm () {
        if (this.freezeAllEvents === true) {
          return
        }

        this.$emit('confirm')
      },
      deleteItem () {
        if (this.freezeAllEvents === true) {
          return false
        }

        this.$emit('deleteItem')
      }
    }
  }
</script>

